import { Dispatcher as BaseDispatcher } from '../BaseDispatcher';

export class Dispatcher extends BaseDispatcher {
    /**
     * A bridge function between the views and the dispatcher, marking the action
     * as a view action.  Another variant here could be handleServerAction.
     */
    public handleViewAction<T>(action: T) {
        this.dispatch({
            source: 'VIEW_ACTION',
            action: action
        });
    }

    public static get() {
        return new Dispatcher();
    }
}
